import { playAudio, deepClone } from "@/utils";
export default {
  namespaced: true,
  state: {
    //设备模版显示控制
    // audioUrl: sessionStorage.getItem("audioPath") || "",
    audioUrl: [],
    playAudioFlag: localStorage.getItem("playAudioFlag") || "0",
    socketAlarmData: null
  },
  mutations: {
    SET_AUDIO_URL(state, audioUrl) {
      const audioArr = state.audioUrl.concat([audioUrl]);
      state.audioUrl = audioArr;
      playAudio(audioArr, state.playAudioFlag);
    },
    SET_PLAY_AUDIO_FLAG(state, playAudioFlag) {
      localStorage.setItem("playAudioFlag", playAudioFlag);
      state.playAudioFlag = playAudioFlag;
      playAudio(state.audioUrl, playAudioFlag, true);
    },
    //当前音频播放完及时删除当前音频路径
    DEL_CUR_AUDIO_URL(state) {
      // const audioCopy = JSON.parse(JSON.stringify(state.audioUrl));
      const audioCopy = deepClone(state.audioUrl);
      state.audioUrl = audioCopy.filter(item => item !== audioCopy[0]);
      if (state.audioUrl.length) {
        playAudio(state.audioUrl, state.playAudioFlag);
      }
    },
    //删除所有音频路径
    DEL_ALL_AUDIO_URL(state) {
      state.audioUrl = [];
    },
    //存储告警的实时数据
    SET_ALARM_DATA(state, socketAlarmData) {
      state.socketAlarmData = socketAlarmData;
    },
    //将告警实时数据置空
    SET_ALARM_DATA_EMPTY(state) {
      state.socketAlarmData = null;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js